module.exports = __webpack_public_path__ + "img/flatex_icon.d4b1e49f.png";